exports.inject = function(module) {
  module.factory('Numbers', ['$http', '$q', exports.factory]);  
};

exports.factory = function($http, $q) {
  function getNumbers(data) {
    if(!data.code) {
      delete data.code;
    }

    return $http.post('/bridges/api/v1/find-numbers', $.param(data || {}), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }
  
  function buyNumber(number) {
    var urlInfo = number.service_provider + '/number/' + number.number;

    if(number.tiedTo !== null){
      urlInfo += '/tie/'+number.tiedTo;
    }

    return $http.post('/bridges/api/v1/provision/'+ urlInfo +'/');
  }
  
  return {
    getNumbers: getNumbers,
    buyNumber: buyNumber
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/number-service.js
 ** module id = 235
 ** module chunks = 0
 **/